import styled from '@emotion/styled';
import { Box } from '@mui/material';
import React from 'react';
import { COLOR_MAP } from '../../constants/ColorNames';
import { UploadIcon } from '../../constants/icons/UploadIcon';


type ImagePlaceholderPropsType = {
  label?: string;
  onClick?: () => void
}

const PlaceholderBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${COLOR_MAP.GREY};
  padding: 1rem 0;
  border-radius: 4px;
  cursor: pointer;
  gap: 8px;
`;

const Label = styled.p`
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: ${COLOR_MAP.DARK_PURPLE};
  margin: 0;
`

export const ImagePlaceholder = (props: ImagePlaceholderPropsType) => {
  const { label, onClick } = props;
  return (
 
  <PlaceholderBox
    onClick={onClick}
    >
      <UploadIcon svgFill={COLOR_MAP.DARK_PURPLE} />
      {label ?
        <Label>{label}</Label>
        : null
      }

    </PlaceholderBox>
    
  )
}
